import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    tileWrapper: 'flex flex-col gap-6',
    base: 'group/tile relative z-0 grid gap-6 max-md:grid-cols-[100px_1fr] max-md:gap-2 md:grid-cols-[120px_1fr_auto_auto]',
    link: 'absolute inset-0 z-10 cursor-pointer',

    imageContainer:
      'bg-blue-light relative size-[120px] max-md:col-start-1 max-md:row-start-1 max-md:size-[100px]',
    image: 'size-full object-contain',
    giftLabel:
      'heading-xs-bold absolute right-1/2 bottom-0 translate-x-1/2 translate-y-1/2',

    content: 'flex flex-1 flex-col gap-3 max-md:col-start-2 max-md:row-start-1',
    header: 'relative z-20 flex flex-row items-center gap-3',
    info: 'flex flex-col gap-1',
    title: 'heading-s-bold mb-1 line-clamp-2 leading-tight',
    description: 'heading-xs lg:heading-s line-clamp-2',

    prices:
      'relative z-20 flex h-full flex-col gap-1 max-md:col-start-2 max-md:row-start-2 max-md:w-full max-md:justify-self-end md:w-[160px]',
    priceRow: 'mb-1 flex flex-col',
    salePrice: 'heading-xs text-secondary-hover flex flex-row gap-1 text-sm',
    controls:
      'relative z-20 mt-3 flex w-full flex-row items-center justify-between max-md:w-[210px]',
    count: 'heading-xs text-secondary-hover',
    buy: 'mt-4 w-full',
    countFree: 'heading-xs text-secondary-hover mt-3',
    actions:
      'max-md:align-self-end relative z-20 flex flex-col items-center gap-4 max-md:col-start-1 max-md:row-start-2 max-md:w-full max-md:justify-end md:pl-4',
    actionItem:
      'link transition-opacity max-md:h-[50px] md:opacity-0 md:group-hover/tile:opacity-100',
    diagnosticLabels:
      'absolute top-1 left-1 mb-2 flex flex-col flex-wrap gap-[2px]'
  },
  variants: {
    type: {
      base: '',
      gift: '',
      order: '',
      unavailable: {
        imageContainer: 'opacity-50',
        content: 'opacity-50'
      },
      sample: ''
    },
    isInWishlist: {
      true: {
        actionItem: '!opacity-100'
      }
    }
  },
  defaultVariants: {
    type: 'base'
  }
});
